import * as t from './actionTypes';

const initialState = { isLoading: false, data: [] };

const dataReducer = (state = initialState, action) => {

  switch (action.type) {
    case t.SET_BUSY:
      return Object.assign({}, state, { isLoading: true });

    case t.UNSET_BUSY:
      return Object.assign({}, state, { isLoading: false });

    case t.DATA_LOAD_SUCCESS:
      let { data } = action;
      if (data) {
        return ({
          ...state,
          data: Object(data),
        })
      }
      else {
        return state;
      }

    default:
      return state;
  }
};

export default dataReducer;
